module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hr-fundamentals-included_600.e548da1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/fullscreen-image_hr-fundamentals-included_600.png
// module id = dFcP
// module chunks = 0